export default __webpack_public_path__ + "static/media/empty-state.3756531b.svg";